import loadable from '@loadable/component'

const CheckoutLoadable = loadable(() => import('./CheckoutNew'));

export default CheckoutLoadable